import DropdownInput from 'components/DropdownInput';

import SearchResult from './components/SearchResult';
import SearchForm from '../SearchForm';

const Search = ({
  match: {
    params: { query },
  },
  history,
}) => (
  <SearchForm history={history} input={query}>
    {({ onEnterKeyPress, onInputClear, options, onChange, value }) => (
      <section className="section section_search-result_1">
        <div className="wrapper">
          <div className="row">
            <div className="col col-8 offset-2 col-tablet-12 offset-tablet-0">
              <div className="search search_outlined _mb-44 _mb-note-34 _mb-phone-24">
                <DropdownInput
                  className="search__input"
                  placeholder="Search our Help Center"
                  onEnterKeyPress={onEnterKeyPress}
                  onInputClear={onInputClear}
                  onChange={onChange}
                  value={value}
                />
              </div>
              <SearchResult options={options} history={history} input={query} />
            </div>
          </div>
        </div>
      </section>
    )}
  </SearchForm>
);

export default Search;
